import React, { Component, Children } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_SPECIFICATION_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import List from './List';
import New from './New';
import Edit from './Edit';

class SMSTemplates extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    params: PropTypes.shape({
      smsTemplateID: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static New = checkChanges(New, { message: NEW_SPECIFICATION_PROMPT })
  static Edit = checkChanges(Edit)

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: null,
    };
  }
  componentDidMount() {
    if (this.props.params.smsTemplateID) {
      this.fetchSMSTemplate();
    } else if (this.props.location.pathname.includes('/new/')) {
      this.fetchSMSTemplates();
    } else {
      this.setLoading(false);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    if (nextProps.params.smsTemplateID) {
      if (pathname !== this.props.location.pathname) {
        this.fetchSMSTemplate();
      }
    } else if (pathname.includes('/new/')) {
      this.fetchSMSTemplates();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchSMSTemplate() {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/sms_templates/${encodeURIComponent(this.props.params.smsTemplateID)}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchSMSTemplates(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign({
      page: 1,
    }, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`/sms_templates/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        smsTemplateID: this.props.params.smsTemplateID,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}


const TranslatedSMSTemplates = withTranslation(namespaces)(SMSTemplates);
TranslatedSMSTemplates.List = SMSTemplates.List;
TranslatedSMSTemplates.New = SMSTemplates.New;
TranslatedSMSTemplates.Edit = SMSTemplates.Edit;
export default TranslatedSMSTemplates;



// WEBPACK FOOTER //
// ./src/containers/SMSTemplates/SMSTemplates.jsx